import { getAppInstance } from '/@/store/session/selectors';
import { getCampaignString } from '/@/utils';

export const getCarbonCalculatorEnabled = (state) => getAppInstance(state).enableCarbonCalculator;
export const getCarbonCalculatorBREnabled = (state) => getAppInstance(state).enableCarbonCalculatorBr;

export const getCampaignsOptions = () => {
    const date = new Date();
    const actualYear = date.getFullYear();
    const lastYearFrom = actualYear - 11;
    const lastYearTo = actualYear + 8;
    const campaigns = [];
    for (var i = lastYearFrom; i <= actualYear - 1; i++) {
        campaigns.push({ label: getCampaignString(i), value: i });
    }
    for (var i = actualYear; i <= lastYearTo; i++) {
        campaigns.push({ label: getCampaignString(i), value: i });
    }
    return campaigns;
};

export const getCampaignFrom = (state) => state.carbonCalculator.campaignFrom;

export const getCampaignTo = (state) => state.carbonCalculator.campaignTo;

export const getSelectedCampaigns = (state) => state.carbonCalculator.selectedCampaigns;

export const getFarmingOptions = (state) => state.carbonCalculator.allFarmingTypes;
export const getSelectedFarmingOption = (state) => state.carbonCalculator.farmingType;

export const getAllSoilTypesOptions = (state) =>
    state.carbonCalculator?.allSoilTypes?.filter(
        (soil) =>
            (soil.apparentDensity !== 0 && soil.clay !== 0 && soil.organicMaterial !== 0) || soil.label === 'Otros'
    );
export const getSoilType = (state) => state.carbonCalculator.soilType;

export const getCrops = (state) => state.carbonCalculator.crops;

export const getClay = (state) => state.carbonCalculator.clay;
export const getOrganicMaterial = (state) => state.carbonCalculator.organicMaterial;
export const getDensity = (state) => state.carbonCalculator.density;

export const getRequiredFieldsComplete = (state) => {
    const { campaignFrom, campaignTo, farmingType, soilType, clay, density, organicMaterial } = state.carbonCalculator;
    return !!campaignFrom && !!campaignTo && !!farmingType && !!soilType && !!clay && !!density && !!organicMaterial;
};

export const getCalculationResult = (state) => state.carbonCalculator.calculationResult;
